/**
 * Font Awesome Configuration
 * 
 * We use the more advanced tree shaking version of FA. This provides a massive performance improvement.
 */
import Vue from 'vue';

// Font Awesome Library component
import { library } from '@fortawesome/fontawesome-svg-core'

// Font Awesome icon packages. Only include what you use
import { faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { faAngleRight } from '@fortawesome/pro-solid-svg-icons'
// import { faMobile } from '@fortawesome/pro-regular-svg-icons'
import { faChevronRight, faChevronLeft, faMapMarkerAlt, faTimesCircle } from '@fortawesome/pro-light-svg-icons'

// The Icon Component
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'; 

// Register icons in the library
library.add(
  // Brands
  faLinkedin, 

  // Solid
  faAngleRight, 

  // Regular
  // none...

  // Light
  faChevronRight, faChevronLeft, faMapMarkerAlt, faTimesCircle
)

// Register the Font Awesome Icon component
Vue.component('font-awesome-icon', FontAwesomeIcon) 